export * from './lib/sku-capsule-feature-sku-capsule.module';
export * from './lib/sku-capsule.component';
